export enum MediaGalleryType {
  EntityMedia = 'entity-media',
}
